import sample from "lodash/sample";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import items from "./TFT-sets/2020-04-16-set3/items.json";
import { AnswerItem, OptionStack } from "./ChampQuiz";

const comboItems = items.filter(
  (i) => i.components && i.components.length === 2
);

const baseItems = items.filter((i) => !i.components);

function ItemQuiz() {
  console.log("here?");
  const [selectedItem1, setSelectedItem1] = useState(null);
  const [selectedItem2, setSelectedItem2] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  useEffect(() => setCurrentItem(sample(comboItems)), []);

  if (!currentItem) {
    return "";
  }

  let isCompleted = false;
  if (selectedItem1 && selectedItem2) {
    isCompleted =
      (currentItem.components[0] === selectedItem1.name &&
        currentItem.components[1] === selectedItem2.name) ||
      (currentItem.components[0] === selectedItem2.name &&
        currentItem.components[1] === selectedItem1.name);
  }

  let isFailed = false;
  if (selectedItem1 && selectedItem2) {
    isFailed =
      (currentItem.components[0] !== selectedItem1.name ||
        currentItem.components[1] !== selectedItem2.name) &&
      (currentItem.components[0] !== selectedItem2.name ||
        currentItem.components[1] !== selectedItem1.name);
  }

  const image = require(`./TFT-sets/2020-04-16-set3/items/${currentItem.id
    .toString()
    .padStart(2, "0")
    .toLocaleLowerCase()
    .replace(/[^A-Z0-9]/gi, "")}.png`);

  return (
    <div
      style={{
        flex: 1,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div>
        <div
          className={classNames("champ-header", {
            success: isCompleted,
            failed: isFailed,
          })}
          style={{ display: "flex", alignItems: "center" }}
        >
          <div style={{ flex: 1 }}>
            <h2>{currentItem.name}</h2>
          </div>
          <div>
            <img src={image} className="App-logo" alt="logo" />
          </div>
          <div className="answer-section" style={{ flex: 1 }}>
            <AnswerItem title="Item 1" root={selectedItem1} />
            <AnswerItem title="Item 2" root={selectedItem2} />
          </div>
        </div>
      </div>
      <div style={{ margin: "10px 0" }}>
        <div style={{ marginBottom: "5px" }}>{currentItem.description}</div>
        {!isCompleted && (
          <button
            onClick={() => {
              setSelectedItem1(
                baseItems.find((t) => t.name === currentItem.components[0])
              );
              setSelectedItem2(
                baseItems.find((t) => t.name === currentItem.components[1])
              );
            }}
            style={{ fontSize: "1em", padding: "2px 5px" }}
          >
            Reveal{" "}
            <span role="img" aria-label="crying-emoji">
              😭
            </span>
          </button>
        )}
        {isCompleted && (
          <button
            onClick={() => window.location.reload(false)}
            style={{ fontSize: "1em", padding: "2px 5px" }}
          >
            Try another!{" "}
            <span role="img" aria-label="crying-emoji">
              🙉
            </span>
          </button>
        )}
      </div>
      <div className="trait-stack-wrapper">
        <div className="trait-section-header">Item 1</div>
        <OptionStack
          selected={selectedItem1}
          options={baseItems}
          setSelected={setSelectedItem1}
          icon={(item) => {
            const image = require(`./TFT-sets/2020-04-16-set3/items/${item.id
              .toString()
              .padStart(2, "0")
              .toLocaleLowerCase()
              .replace(/[^A-Z0-9]/gi, "")}.png`);

            return (
              <img
                src={image}
                className="trait-icon"
                alt="Trait Icon"
                style={{ marginRight: "5px" }}
              />
            );
          }}
        />
        <div className="trait-section-header">Item 2</div>
        <OptionStack
          selected={selectedItem2}
          options={baseItems}
          setSelected={setSelectedItem2}
          icon={(item) => {
            const image = require(`./TFT-sets/2020-04-16-set3/items/${item.id
              .toString()
              .padStart(2, "0")
              .toLocaleLowerCase()
              .replace(/[^A-Z0-9]/gi, "")}.png`);

            return (
              <img
                src={image}
                className="trait-icon"
                alt="Trait Icon"
                style={{ marginRight: "5px" }}
              />
            );
          }}
        />
      </div>
    </div>
  );
}

export default ItemQuiz;
